import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class SettlementCheckModel extends BaseModel {
  static urlPath = "settlement_checks";

  @belongsTo("case") case;
  @belongsTo("user") createdBy;
  @belongsTo("user") updatedBy;
  @belongsTo("entity") paidBy;
  @belongsTo("entity") paidTo;
  @attr("string") createdAt;
  @attr("string") updatedAt;
  @attr("string") checkNumber;
  @attr("string") amount;
  @attr("string") checkDate;
  @attr("number") checkType;
}
